// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router/index'
import VueAxios from 'vue-axios'
import axios from 'axios'
import store from './store'
import VeeValidate from 'vee-validate'
import VScrollLock from 'v-scroll-lock'
import vSelect from 'vue-select'

import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'

const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn',
}

miniToastr.init({
    types: toastTypes,
})

function toast({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
}

Vue.use(VueNotifications, {
    success: toast,
    error: toast,
    info: toast,
    warn: toast,
})

Vue.use(VeeValidate, {fieldsBagName: 'veeFields'})
Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
Vue.use(VScrollLock)

Vue.component('v-select', vSelect)

Vue.router = router

axios.interceptors.response.use(
    response => {
        store.commit('auth/SET_UNAUTHORIZED_RETRIED', false)
        return response
    },
    error => {
        return new Promise(async (resolve, reject) => {
            if (error.config && error.config.url === `${process.env.VUE_APP_NODE_API_HOST}/auth/refresh`) {
                store.commit('auth/SET_UNAUTHORIZED_RETRIED', false)
                localStorage.removeItem('refreshToken')
                localStorage.removeItem('accessToken')
                router.push('/auth/login')
                return reject(error)
            }
            if (
                error.response &&
                error.response.status === 401 &&
                localStorage.refreshToken &&
                !store.state.auth.unauthorizedRetried
            ) {
                const response = await axios.post(process.env.VUE_APP_NODE_API_HOST + '/auth/refresh', {
                    refreshToken: localStorage.refreshToken,
                })
                const {refreshToken, accessToken} = response.data.data
                localStorage.refreshToken = refreshToken
                localStorage.accessToken = accessToken
                const {Authorization, ...headers} = error.config.headers
                const newHeaders = Object.assign({}, headers, {Authorization: `Bearer ${accessToken}`})
                const retry = Object.assign({}, error.config, {headers: newHeaders})
                store.commit('auth/SET_UNAUTHORIZED_RETRIED', true)
                return resolve(axios.request(retry))
            }
            if (error.response && error.response.status === 401 && store.state.auth.unauthorizedRetried) {
                return reject()
            }
            return reject(error)
        })
    }
)

Vue.use(require('@websanova/vue-auth'), {
    auth: {
        request: function(req, token) {
            this.options.http._setHeaders.call(this, req, {
                Authorization: 'Bearer ' + token,
                'x-codelab-project-id': store.state.project.active ? store.state.project.active.id : undefined,
                'x-codelab-category-id': store.state.category.active ? store.state.category.active.id : undefined,
            })
        },

        response: function(res) {
            if (res.data.data && res.data.data.refreshToken) {
                localStorage.refreshToken = res.data.data.refreshToken
            }
            if (res.data.data && res.data.data.accessToken) {
                return res.data.data.accessToken
            }
        },
    },
    tokenDefaultName: 'accessToken',
    loginData: {
        url: process.env.VUE_APP_NODE_API_HOST + '/auth/login',
        fetchUser: true,
    },
    logoutData: {
        url: process.env.VUE_APP_NODE_API_HOST + '/auth/logout',
        method: 'POST',
        redirect: '/',
        makeRequest: true,
    },
    fetchData: {
        url: process.env.VUE_APP_NODE_API_HOST + '/users/self',
        method: 'GET',
        enabled: true,
    },
    refreshData: {enabled: false},
    registerData: {
        url: process.env.VUE_APP_NODE_API_HOST + '/users',
        method: 'POST',
        redirect: '/auth/login?registered=true',
    },
    authRedirect: {path: '/auth/login'},
    notFoundRedirect: {path: '/404'},
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
})

router.beforeEach((to, from, next) => {
    if (to.path.includes('auth')) {
        next()
    } else {
        store.dispatch('project/getProjects').then(async projects => {
            if (!projects.length && to.path !== '/iam/projects/create') {
                localStorage.removeItem('activeProjectId')
                store.commit('project/SET_PROJECT', null)
                next('/iam/projects/create')
            } else {
                if (localStorage.activeProjectId) {
                    const activeProject = projects.find(el => el.id === localStorage.activeProjectId)
                    if (activeProject) {
                        store.commit('project/SET_PROJECT', activeProject)
                    } else {
                        if (projects.length > 0) {
                            store.commit('project/SET_PROJECT', projects[0])
                        } else {
                            localStorage.removeItem('activeProjectId')
                            store.commit('project/SET_PROJECT', null)
                        }
                    }
                } else {
                    store.commit('project/SET_PROJECT', projects[0])
                }
                if (to.path.includes('codelabs')) {
                    const categories = await store.dispatch('category/getCategories', store.state.project.active.id)
                    if (localStorage.activeCategoryId) {
                        const activeCategory = categories.find(el => el.id === localStorage.activeCategoryId)
                        if (activeCategory) {
                            store.commit('category/SET_CATEGORY', activeCategory)
                        }
                    }
                }
            }
            next()
        })
    }
})

import dotenv from 'dotenv'
dotenv.config()

new Vue({
    el: '#app',
    router,
    store,
    axios,
    template: '<App/>',
    components: {
        App,
    },
})
